import { useState, useEffect } from "react";
import { getAppToken } from "../services/auth";

export const useAuthToken = () => {
  const [isLoadingToken, setIsLoadingToken] = useState(false);
  const [appToken, setAppToken] = useState(
    localStorage.getItem("access_token_bt")
  );

  const getAuthToken = async () => {
    setIsLoadingToken(true);
    try {
      const response = await getAppToken();
      if (response.data) {
        localStorage.setItem("access_token_bt", response.data.access_token);
        localStorage.setItem("refresh_token_bt", response.data.access_token);
        setAppToken(response.data.access_token);
      }
    } catch (err) {
      console.error("usePayments:getAuthToken", err);
    } finally {
      setIsLoadingToken(false);
    }
  };
  return { getAuthToken, isLoadingToken, appToken };
};
